<section
  class="ui-page-shell"
  [class.ui-page-shell-padded]="padded()"
  [class.ui-page-shell-with-tabbar]="hasTabbar()"
  [attr.aria-label]="ariaLabel()"
>
  <header class="ui-page-shell-header">
    <ng-content select="[uiPageShellHeader]" />
  </header>
  <main class="ui-page-shell-body">
    <ng-content />
  </main>
  <footer class="ui-page-shell-footer">
    <ng-content select="[uiPageShellFooter]" />
  </footer>
</section>
